import React from "react"; 
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"; 
import useMediaQuery from "@mui/material/useMediaQuery"; 
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal"; 
import { MultipleCard } from "./MultipleCard";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
 
const GCMultipleCard = ({
  xOpen = false,
  fCloseDetailModal, 
  xTitle = "Card Detail",
  sMultipleCard=[],
  onClickMultipleCard,
}) => { 

  return (
    <Modal
      open={xOpen}
      onClose={fCloseDetailModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-gc-search"
      >
         
        <GCTitleSticky title={xTitle} onClose={fCloseDetailModal} />
          
        <div className="p-2">
          
        {sMultipleCard?.length > 0 && (
          <Box>
            <Grid
              container
              spacing={{ xs: 0, md: 3 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              {sMultipleCard?.map((obj, index) => (
                <Grid item xs={12} sm={12} md={3} key={index}>
                  <MultipleCard
                    CARDID={obj.CARDID}
                    Stock={obj.Stock}       
                    onClick={() => { 
                      onClickMultipleCard(obj)
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        )} 
        </div>
      </Box>
    </Modal>
  );
};

export default GCMultipleCard;
